import { i18n } from 'core/localization';
let qualifiers = {
	getCalculatedProperties(qualifier) {
		let result = {
			inWarning: false,
			inMaintenance: false,
			iconTooltip: '',
			displayName: qualifier.name,
		};

		let tooltipParts = [];
		if (qualifier.agentStatus === 'AGENT_DOWN') {
			tooltipParts.push(i18n('Agent in warning'));
			result.inWarning = true;
		}

		if (qualifier.agentStatus == 'AGENT_MAINTENANCE') {
			tooltipParts.push(i18n('Agent in maintenance'));
			result.inMaintenance = true;
		}

		if (qualifier.qualifierError) {
			tooltipParts.push(i18n('Qualifier error'));
			result.inWarning = true;
		}

		if (qualifier.assetMaintenance) {
			tooltipParts.push(i18n('Asset in maintenance'));
			result.inMaintenance = true;
		}

		if (qualifier.operatingState === 'IN_MAINTENANCE') {
			tooltipParts.push(i18n('Service in maintenance'));
			result.inMaintenance = true;
		}

		tooltipParts.push(
			(qualifier.shared ? i18n('Shared servicequalifier') : i18n('Servicequalifier')) + ': ' + qualifier.name,
		);

		result.iconTooltip = tooltipParts.join(' / ');
		return result;
	},
};

export function updateFromEvent(qualifierOrQualifiers, newData) {
	let qualifier = qualifierOrQualifiers;
	if (Array.isArray(qualifierOrQualifiers)) {
		qualifier = qualifierOrQualifiers.find((q) => q.id == newData.sourceId);
	}

	if (qualifier == null) return false;

	let changed = false;

	if (qualifier.state != newData.status) {
		qualifier.state = newData.status;
		changed = true;
	}

	if (qualifier.agentStatus != newData.agentStatus) {
		qualifier.agentStatus = newData.agentStatus;
		changed = true;
	}

	if (qualifier.qualifierError != newData.qualifierError) {
		qualifier.qualifierError = newData.qualifierError;
		changed = true;
	}

	if (qualifier.assetMaintenance != newData.assetMaintenance) {
		qualifier.assetMaintenance = newData.assetMaintenance;
		changed = true;
	}

	if (qualifier.operatingState != newData.operatingState && newData.operatingState !== undefined) {
		qualifier.operatingState = newData.operatingState;
		changed = true;
	}

	return changed;
}

export default qualifiers;
